var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type)?_c('div',{staticClass:"stripe-tips"},[_vm._v("Bezahlung erfolgreich!")]):_c('div',{staticClass:"stripe-tips"},[_vm._v("Bezahlung fehlgeschlagen!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }